import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import type ChargeResponse from "entities/chargeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export class ChargeVehicleChangeRequest {
  /**
   * Changed country ID.
   */
  @observable
  countryId!: string;

  /**
   * Changed license plate.
   */
  @observable
  licensePlate!: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * Email address.
   */
  @observable
  emailAddress?: string;

  @observable
  oldLicensePlate: string;

  @observable
  oldCountryId: string;
}

export class ChargeVehicleChange extends ChargeVehicleChangeRequest {
  constructor(charge: ChargeResponse) {
    super();
    this.oldLicensePlate = charge.vehicle.licensePlate;
    this.countryId = charge.vehicle.countryId;
    this.oldCountryId = charge.vehicle.countryId;
    this.emailAddress = charge.emailAddress;
  }
}

export const ChargeVehicleChangeValidationRules: EntityValidationRules<ChargeVehicleChangeRequest> = {
  countryId: {
    required: true,
    isNotEqual: {
      condition: (entity: ChargeVehicleChange) =>
        entity.countryId &&
        entity.licensePlate &&
        entity.oldCountryId.toString().trim() === entity.countryId.toString().trim() &&
        entity.oldLicensePlate.toString().trim() === entity.licensePlate.toString().trim()
          ? entity.countryId.toString().trim()
          : "",
    },
  },
  licensePlate: {
    required: true,
    isLicensePlate: true,
    isNotEqual: {
      condition: (entity: ChargeVehicleChange) =>
        entity.countryId &&
        entity.licensePlate &&
        entity.oldCountryId.toString().trim() === entity.countryId.toString().trim() &&
        entity.oldLicensePlate.toString().trim() === entity.licensePlate.toString().trim()
          ? entity.licensePlate.toString().trim()
          : "",
    },
  },
  officialRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
  emailAddress: {
    isEmail: {
      required: false,
    },
  },
};
